





















import Vue from "vue";
export default Vue.extend({
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      required: true
    },
    size: {
      type: String //sm - md - lg
    },
    background: {
      type: Boolean
    }
  },
  methods: {
    test(e) {
      console.log(e);
    },
    onInput(e: InputEvent) {
      let value = (e.target as HTMLInputElement).value;
      console.log(value);

      if (value === "") {
        this.$emit("input", 0);
        return;
      }
      value = value.replace("$", "").replace(/,/g, "");
      console.log(value);
      console.log(parseFloat(value));

      this.$emit("input", parseFloat(value));
      // const isValidNumber = /[0-9]/.test(value);
      // console.log(isValidNumber);

      // if (!isValidNumber && value !== "") {
      //   this.$emit("input", 0);
      //   this.$emit("input", this.value);
      //   return;
      // }
      // if (value === "") {
      //   this.$emit("input", 0);
      //   return;
      // }
      // this.$emit("input", parseInt(value));
    }
  }
});
